import { array, InferType, number, object } from 'yup'

export const addDailyCreditsByEmailSchema = object({
  emails: array<string[]>().min(1).required('Required'),
  credits: number().min(1).max(365).required('Required'),
  offerIds: array<string[]>().min(1).required('Required'),
})

export type AddDailyCreditsByEmailFormValues = InferType<typeof addDailyCreditsByEmailSchema>
